import React from 'react';

import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

import { ScrollOffset as BaseScrollOffset } from '~/techstyle-shared/react-components';

const ScrollOffsetWrapper = styled(BaseScrollOffset)`
  ${({ theme }) => theme.pdpScrollOffset};
`;

const ScrollOffset = React.forwardRef(({ children, ...rest }, ref) => {
  const theme = useTheme();

  const { mobile, desktop } = theme.header.height;

  return (
    <ScrollOffsetWrapper
      offset={desktop}
      mobileOffset={mobile}
      {...rest}
      ref={ref}
    >
      {children}
    </ScrollOffsetWrapper>
  );
});

ScrollOffset.displayName = BaseScrollOffset.displayName;

ScrollOffset.propTypes = {
  children: PropTypes.node,
};

export default ScrollOffset;
